<template>
  <transition name='slide-fade'>
    <div class='page-component-bottom' v-if='isShowToBottom' @click='getBottom'>
      <i class="el-icon-caret-bottom"></i>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'ToBottom',
  data () {
    return {
      isShowToBottom: true
    }
  },
  methods: {
    //  添加样式，鼠标hover上去，改变颜色
    addhoverClass (e) {
      if (e.type === 'mouseover' && this.$el.classList) {
        this.$el.classList.add('hover')
      } else if (e.type === 'mouseout' && this.$el.classList) {
        this.$el.classList.remove('hover')
      }
    },
    showToBottomIcon () {
      let marginBottom = (document.documentElement.scrollHeight - document.documentElement.scrollTop)
      if (marginBottom > document.documentElement.clientHeight + 100) {
        this.isShowToBottom = true
        this.$el.addEventListener('mouseover', this.addhoverClass)
        this.$el.addEventListener('mouseout', this.addhoverClass)
      } else if (marginBottom <= document.documentElement.clientHeight + 100) {
        this.isShowToBottom = false
      }
    },
    getBottom () {
      document.documentElement.scrollTop = document.documentElement.scrollHeight
    }
  },
  mounted () {
    this.showToBottomIcon()
    window.addEventListener('scroll', this.showToBottomIcon)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.showToBottomIcon)
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
.slide-fade-enter-active {
  transition: all .1s ease;
}
.slide-fade-leave-active {
  transition: all .1s cubic-bezier(1.0, 0.3, 0.8, 1.0);
  opacity: 0;
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active 在低于 2.1.8 版本中 */ {
  // transform: translateY(-20px);
  opacity: 0;
}
.page-component-bottom {
  background-color: #409EFF;
  position: fixed;
  right: 3rem;
  bottom: 4rem;
  width: 50px;
  height: 50px;
  border-radius: 25px;
  cursor: pointer;
  opacity: .3;
  transition: .3s;
  text-align: center;
  z-index: 999;
}
.el-icon-caret-bottom {
  font-size: 36px;
  margin-top: 7px;
  color: #FFFFFF;
  text-align: center;
  z-index: 1000
}
.hover {
  opacity: .9;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ToBottom.vue